@if (visible) {
  <div (click)="click($event)" class="popup-overlay">
    <div class="popup">
      <ng-content></ng-content>
    </div>
  </div>
}
